module.exports = __webpack_public_path__ + "img/card_number.946c2f3f.svg";